/* eslint-disable max-len */
export const DIVISION_CARDS = [
  {
    id: 1,
    title: 'Разрабатываем',
    to: '/tech',
    isNavLink: true,
  },
  {
    id: 2,
    title: 'Развиваем',
    to: '/office',
    isNavLink: true,
  },
  {
    id: 3,
    title: 'Поддерживаем',
    to: '/operations',
    isNavLink: true,
  },
  {
    id: 4,
    title: 'Доставляем',
    to: 'https://job.sbermarket.ru',
    isNavLink: false,
  },
];
